export default {
  'rbac_settings.teams.delete_team_external_integration.dialog_content.text.delete_status_check.warning':
    'Health Checks using this integration will fail their Reliability Tests.',
  'rbac_settings.teams.delete_team_external_integration.dialog_content.text.delete_integration.warning':
    'Services using this integration will fail their Reliability Tests.',
  'rbac_settings.teams.notifications.scheduled_status_checks.failed_health_check.author_notification':
    'The scenario author {{enableSetting}} be notified of any failed Health Checks',
  'rbac_settings.teams.notifications.scheduled_status_checks.failed_health_check.enable':
    'Enable notifications for failed Health Checks in a scheduled scenario.',
  'rbac_settings.teams.notifications.scheduled_status_checks.failed_health_check.team_notification':
    'Your team {{enableSetting}} be notified of any failed Health Checks',
  'rbac_settings.teams.notifications.scheduled_status_checks.row.header':
    'Scheduled Health Checks',
  'rbac_settings.payment.cancel_button.text': 'Cancel Subscription',
  'rbac_settings.payment.cancel_error.text':
    'There was an issue cancelling your subscription. Please try again later.',
  'rbac_settings.payment.cancel_modal.back_button': 'Back',
  'rbac_settings.payment.cancel_modal.cancel_button': 'Cancel Subscription',
  'rbac_settings.payment.cancel_modal.text':
    'Your company will lose access by the end of the current month.',
  'rbac_settings.payment.cancel_modal.title':
    'Are you sure you want to cancel your Gremlin RM subscription?',
  'rbac_settings.payment.external_payment_link.text': 'Edit payment details',
  'rbac_settings.payment.service_consumed.text': 'Service consumed',
  'rbac_settings.payment.service_invoice_total.text': 'Invoice total',
  'rbac_settings.payment.service_next_invoice_date.text':
    'Next invoice issue date',
  'rbac_settings.teams.team_external_integration_authentication.authentication_type.header':
    '{{externalIntegrationType}} Authentication',
  'rbac_settings.teams.test_status_check.cancel_button.text':
    'Cancel Test Health Check',
  'rbac_settings.teams.test_status_check.loading_button.text':
    'Test Health Check'
}
